<template>
  <div id="aInspectionTaskMap" class="map-container"></div>
</template>

<script>
import { queryAdminInspectionTaskDetail } from '@/api/inspection/adminInspectionTaskDetailApi'
import { loadTianditu } from '@/utils/tianditu'
import { storeToTianditu } from '@/utils/coordTransform'

const DONE_STATE = '20200405'

export default {
  name: 'AInspectionTaskMap',
  data() {
    return {
      map: null,
      points: [],
      markers: [],
      storeCoord: 'GCJ02'
    }
  },
  beforeDestroy() {
    this.clearOverlays()
    this.map = null
  },
  methods: {
    loadData(params) {
      this.initMap(params)
    },
    async initMap(params) {
      try {
        const { data } = await queryAdminInspectionTaskDetail({
          taskId: params.taskId,
          page: 1,
          row: 1000
        })
        this.points = data || []
        const { T, config } = await loadTianditu()
        this.storeCoord = config.STORE_COORD || 'GCJ02'
        this.renderMap(T)
      } catch (error) {
        console.error(error)
        this.$message && this.$message.error(error.message || '加载失败')
      }
    },
    renderMap(T) {
      this.clearOverlays()
      if (!this.points || this.points.length === 0) return
      const dom = document.getElementById('aInspectionTaskMap')
      if (!dom) return

      const first = storeToTianditu(this.points[0].lng, this.points[0].lat, this.storeCoord)
      this.map = new T.Map(dom)
      this.map.centerAndZoom(new T.LngLat(first.lng, first.lat), 17)
      this.map.addControl(new T.Control.Zoom())
      this.map.addControl(new T.Control.Scale())

      this.points.forEach(point => {
        if (!point.lng || !point.lat) return
        const display = storeToTianditu(point.lng, point.lat, this.storeCoord)
        const done = point.state === DONE_STATE
        const icon = new T.Icon({
          iconUrl: done ? '/img/inspection_done.png' : '/img/inspection.png',
          iconSize: new T.Point(25, 35),
          iconAnchor: new T.Point(12, 35)
        })
        const marker = new T.Marker(new T.LngLat(display.lng, display.lat), { icon })
        this.map.addOverLay(marker)
        this.markers.push(marker)
      })
    },
    clearOverlays() {
      if (!this.map) {
        this.markers = []
        return
      }
      this.markers.forEach(m => this.map.removeOverLay(m))
      this.markers = []
    }
  }
}
</script>

<style scoped>
.map-container {
  height: 600px;
  width: 100%;
}
</style>
